let autoplayResult = null;

const shouldAutoplay = () => {
  if (autoplayResult !== null) {
    return autoplayResult;
  }

  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const disableAutoplay = mediaQuery && mediaQuery.matches;
  return !disableAutoplay;
};

const initVideo = (container) => {
  const video = document.createElement('video');
  const videoUrl = container.dataset.videoUrl;

  video.src = videoUrl;
  video.muted = true;
  video.loop = true;
  video.autoplay = shouldAutoplay();
  video.playsInline = true;

  container.insertBefore(video, container.firstChild);
  container.dataset.lazyVideo = 'loaded';

  const playPauseBtn = container.querySelector('.hero-section__video-button');

  playPauseBtn.addEventListener('click', () => {
    const video = container.querySelector('video');
    const playSpan = container.querySelector('.play');
    const pauseSpan = container.querySelector('.pause');

    if (video.paused) {
      video.play();
      pauseSpan.classList.add('active');
      playSpan.classList.remove('active');
    } else {
      video.pause();
      pauseSpan.classList.remove('active');
      playSpan.classList.add('active');
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  const videoContainers = document.querySelectorAll(
    ".hero-section__video--container[data-lazy-video='true']"
  );

  // If we don't support this then we'll just have to load vidoes as normal
  if (!('IntersectionObserver' in window)) {
    console.warn('No intersection observer so load videos normally');
    videoContainers.forEach(function (container) {
      initVideo(container);
    });
    return;
  }

  const options = {
    threshold: 0.05,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        initVideo(entry.target);
      }
    });
  }, options);

  videoContainers.forEach((element) => {
    observer.observe(element);
  });
});
